import type { FaireProductEntity } from "../../entity_types/product";

export const beverage_1: FaireProductEntity = {
  token: "beverage-1",
  type: "product",
  name: "Artisan Coffee Blend",
  brandName: "Craft Beverages",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/d3536a31a25a764ec8df300e640932116da4e34077e080660c443f76eb9994cf.webp",
  priceDollars: 18,
  msrpDollars: 28,
  freeShipping: true,
  isBestseller: true,
  description: "",
  tags: [],
  inStock: true,
  categoryTokens: ["cat_food-drink"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
